var $J = jQuery.noConflict();
$J(document).ready(function () {
	"use strict";
	initDynamicGrid();
	$J('#dynamicdata1').hide();
	$J('#dynamicdata2').hide();
});
var debug = true;
/*
============================================================================
	SOLR Module
============================================================================
*/

function changeUrl(page, url) {
	if (typeof (history.pushState) != "undefined") {
		var obj = {
			Page: page,
			Url: url
		};
		history.pushState(obj, obj.Page, obj.Url);
	} else {
		window.location.href = "homePage";
		// alert("Browser does not support HTML5.");
	}
}

function parseURLParams(url) {
	var queryStart = url.indexOf("?") + 1,
		queryEnd = url.indexOf("#") + 1 || url.length + 1,
		query = url.slice(queryStart, queryEnd - 1),
		pairs = query.replace(/\+/g, " ").split("&"),
		parms = {},
		i, n, v, nv;

	if (query === url || query === "") return;

	for (i = 0; i < pairs.length; i++) {
		nv = pairs[i].split("=", 2);
		n = decodeURIComponent(nv[0]);
		v = decodeURIComponent(nv[1]);

		if (!parms.hasOwnProperty(n)) parms[n] = [];
		parms[n].push(nv.length === 2 ? v : null);
	}
	return parms;
}
(function ($J) {
	$J.fn.valList = function () {
		return $J.map(this, function (elem) {
			return elem.value || "";
		}).join(",");
	};
})(jQuery);
function initSolrWidgetReadNext(){
	"use strict";
	
	initSolrWidgetReadNextResize();
	$J('.arrow-readnext-module .slick-prev').click(function(){
		 $J(this).closest('.widget-readnext').find('.carousel-readnext-module').slick('slickPrev');
	});
	$J('.arrow-readnext-module .slick-next').click(function(){
		 $J(this).closest('.widget-readnext').find('.carousel-readnext-module').slick('slickNext');
	});
	
}
function initSolrWidgetReadNextResize(){
	"use strict";
	console.log('resize');
	if(!$J('.solr-dynamic-grid.carousel-readnext-module').length){
		return;
	}
		
	$J('.solr-dynamic-grid.carousel-readnext-module').each(function(){
		console.log('init carousel');
		$J(this).on('init', function(event, slick){
			$J(this).closest('.carousel-readnext-module').css('opacity','1');
			if (($J(this).find('.slick-slide').length >3)) {
				$J(this).closest('.widget-readnext').find('.arrow-readnext-module').addClass('show');
			}
		});
		
		if($J(this).hasClass('slick-initialized')) { $J(this).slick('unslick'); }

		$J(this).slick({
			arrows:false,
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			infinite: $J('body').hasClass('editing') ? false : true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: false
					}
				},
				{
					breakpoint: 850,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						dots:true,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots:true,
					}
				}
			]
		});
		console.log($J(this));
		goTo($J(this));
	});
}
var goTo = function(now){
	console.log('go to')
	now.slick("slickGoTo", 0);
}
/*
============================================================================
	Solr Dynamic Grid & Carousels
============================================================================
*/

var initDynamicGrid = function (){
	// Find all of the search boxes that need to bind with autocomplete
	$J('.solr-dynamic-grid').each(function () {
		var this_ = $J(this);
		searchSig = this_.data('search-signature');
		var isCarousel = this_.data('carousel');
		this_.closest('div.solr-container').append('<div class="solr-wait-animation"></div>');
		console.log(isCarousel);
		var dynamicGrid = new solrDynamicGrid();
		dynamicGrid.target = this_;
		
		if(isCarousel) {
			console.log('activate carousel');
			this_.addClass('carousel-readnext-module');
			dynamicGrid.request(dynamicGrid.renderThis);
		} else {
			this_.closest('.grid-related-content').addClass('article-grid-view');
			this_.addClass('carousel-grid-article-lists');
			dynamicGrid.request(dynamicGrid.renderNonCarousel);
		}
	});
}

var solrDynamicGrid = function() {
	this.target= $J('#target');
	this.renderThis = function(el, response) {
		el.closest('.solr-container').removeClass('loading');
		templateIdentifier = el.data('solr-template');
		var template = $J(templateIdentifier).html();
		if(template){
			//template = _.template(template); // DISABLE UNDERSCORE.JS
			var html = [];
			if(response.Results){
				response.Results.forEach(function (value, index) {
					// html += template( {
					// 	item: value
					// });
					html += '<div class="item">'+
						'<a href="'+value.AbsoluteUrl +'" class="grid-item-inner-wrap">'+
							'<div class="wrapper-grid-item-content">'+
								'<div class="grid-item-content">'+
									'<small>'+value.ContentType+'</small>'+
									'<h3>'+value.Title+'</h3>'+
									'<div class="me-icon-arrow-grid"></div>'+
								'</div>'+
							'</div>'+
						'</a>'+
					'</div>';
				});

				target = el;
				var car = target.closest('.carousel-related-content');
				//car.slick('unslick'); /* ONLY remove the classes and handlers added on initialize */
				target.append(html);
				initSolrWidgetReadNext();
				arrowDiv = el.closest('.widget-related-content').find('.arrow-carousel-related');
				if ((response.Count < 4)) {
					arrowDiv.hide();
				} else {
					arrowDiv.show();
				}
			} else {
				console.error('Dynamic Grid - Carousel return error, check API return.');
			}
		} else {
			console.error('data-templates null or no template element available. <script type="template-x/solr" id="templateId">');
		}
	}
	this.renderNonCarousel = function(el, response) {
		el.closest('.solr-container').removeClass('loading')
		templateIdentifier = el.data('solr-template');
		var template = $J(templateIdentifier).html();
		if(template){
			template = _.template(template);
			var html = [];
			if(response.Results){
				response.Results.forEach(function (value, index) {
					html += template( {
						item: value
					});
				});
				target = el;
				target.append(html);
			} else {
				console.error('Dynamic Grid return error, check API return.');
			}
		} else {
			console.error('data-templates null or no template element available. <script type="template-x/solr" id="templateId">');
		}
	}
	this.request = function (callback) {
		if (debug) console.log('Request');
		var callback = (typeof callback !== 'undefined') ? callback : this.renderNonCarousel;
		//el.css({ opacity: 0.2 });
		this.target.closest('.solr-container').addClass('loading');
		searchQueryData = {
			itemid: this.target.data('search-id'),
			q: this.target.data('search-keyword'),
			s: this.target.data('search-scope'),
			f: this.target.data('search-facets'),
			o: this.target.data('search-sort-order'),
			l: this.target.data('search-limit'),
			x: this.target.data('search-extra'),
			searchglobal: this.target.data('search-global'),
			data1: $J('#dynamicdata1').html(),
			data2: $J('#dynamicdata2').html(),
		};
		var el = this.target;
		this.xhr = $J.ajax({
			type: "GET",
			url: this.target.data('search-api'),
			data: searchQueryData,
			success: function (msg) {
				if (debug) console.log(msg);
				setTimeout( 
					callback(el,msg), 
					1000);
			}
		});
	}
}

/*
============================================================================
	end SOLR Module
============================================================================
*/